import type { IMetadataKeyRepository } from '@app/domain/ports';
import { isSecondaryMetadataKey } from './metadata-key-routing-policy';

export class RoutingMetadataKeyRepository implements IMetadataKeyRepository {
  constructor(
    private readonly primary: IMetadataKeyRepository,
    private readonly secondary: IMetadataKeyRepository,
  ) {}

  async get<T = unknown>(key: string): Promise<T | undefined> {
    if (!isSecondaryMetadataKey(key)) {
      return this.primary.get<T>(key);
    }

    // Security keys live in localStorage (secondary) only.
    return this.secondary.get<T>(key);
  }

  async set<T = unknown>(key: string, value: T): Promise<void> {
    if (isSecondaryMetadataKey(key)) {
      // Security keys are stored in localStorage only.
      await this.secondary.set(key, value);
      return;
    }

    await this.primary.set(key, value);
  }

  async delete(key: string): Promise<void> {
    if (isSecondaryMetadataKey(key)) {
      await this.secondary.delete(key);
      return;
    }

    await this.primary.delete(key);
  }

  async clear(): Promise<void> {
    await this.primary.clear();
    await this.secondary.clear();
  }
}
